import { http } from "../services/api";
import CheersApiService from "../services/api/CheersApiService";
import { singleLazyInstance } from "../utils/singleLazyInstance";
import CheersStore from "./CheersStore";

export default {
  get cheers(): CheersStore {
    return singleLazyInstance("retailer", () => new CheersStore(new CheersApiService(http)));
  },
};
